<template>
  <div>
      <el-table :data="deviceDataList"  style="width: 100%" height="100%" :header-row-style="getRowClass" :row-style="tableRowStyle"
    :header-cell-style="tableHeaderColor">
        </el-table-column>
        <el-table-column prop="name" label="属性名称">
        </el-table-column>
        <el-table-column prop="val" label="采集数据">
        </el-table-column>
         <!-- <el-table-column prop="date" label="采集时间">
        </el-table-column> -->
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "device_list",
  props: {
    deviceDataList: {
      type: Array
    },
  },
  data() {
    return {
      is_loading: false,
      alarmRed: "",
       tableData: [{
            // date: '2016-05-04 09:28:12',
            name: '进口压力',
            address: '100%LEL'
          }, {
            // date: '2016-05-04 09:28:12',
            name: '出口压力',
            address: '100%LEL'
          }, {
            // date: '2016-05-04 09:28:12',
            name: '进口温度',
            address: '10℃'
          }, {
            // date: '2016-05-04 09:28:12',
            name: '出口温度',
            address: '10℃'
          }, {
            // date: '2016-05-04 09:28:12',
            name: '电池电压',
            address: '5V'
          }]
    };
  },
  mounted() {
    // this.alarmRed =this.deviceDataList.alarmRed;
    // console.log(this.alarmRed,this.deviceDataList)
  },
  methods: {
    // alarmTime
    tableRowStyle({ row, rowIndex }) {
      return 'background-color:red;font-size:12px;'
    },
    // 设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return 'background-color:transparent!important;color:#fff;font-wight:500;font-size:15px;text-align:left'
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
    return "background:#3f5c6d2c;"
    },
  },
};
</script>

<style scoped lang="less">
& /deep/  .el-table--fit{
        // padding: 20px;
        color: rgb(146, 219, 241);
}
& /deep/    .el-table, .el-table__expanded-cell {
    background-color: transparent;
}

 & /deep/   .el-table tr {
    background-color: transparent!important;
}
 & /deep/  .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #3f71b1;

}
& /deep/   .el-table::before {//去掉最下面的那一条线
	height: 0px;
}
& /deep/   .el-table th, .el-table tr {
    background-color: transparent!important;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/table_devdata_list.vue